import { apiListCameraImagePastFlood, apiListCameraSensorHistories6hAgo } from 'apis/SensorApi';
import Icon, { IconList } from 'components/Icon';
import { SENSOR_STATUS_ALERT } from 'constants/config';
import { TEXT_DATA_RECEIVED_DATETIME, TEXT_FLOOD_GATE_OPENING_LEVEL, TEXT_INNER_WATER_LEVEL, TEXT_LATITUDE, TEXT_LONGITUDE, TEXT_MANAGEMENT_ID, TEXT_MESSAGE, TEXT_NAME, TEXT_OUTER_WATER_LEVEL, TEXT_POWER_VOLTAGE, TEXT_STATUS } from 'constants/message';
import { useAuth } from 'context/AuthContext';
import { useGeneralSetting } from 'context/GeneralSettingContext';
import { useSensorGroups } from 'context/SensorGroupsContext';
import { useSensors } from 'context/SensorsContext';
import { AccountType, LockState, SensorType } from 'models';
import CameraDisplayer from 'pages/components/CameraDisplayer';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { SENSOR_PROPERTIES, UNDEFINED_TEXT } from 'utils/constanst';
import { addCommasToNumber, convertDateFormat, hexToRGB } from 'utils/function';
import '../MapPage.css';
import { getUrl } from 'aws-amplify/storage';
import { useNavigate } from 'react-router-dom';

const FLOOD_SENSOR_INFO = [
  {
    label: TEXT_MANAGEMENT_ID,
    key: SENSOR_PROPERTIES.MANAGE_ID
  },
  {
    label: TEXT_NAME,
    key: SENSOR_PROPERTIES.NAME,
  },
  {
    label: TEXT_DATA_RECEIVED_DATETIME,
    key: SENSOR_PROPERTIES.TX,
  },
  {
    label: TEXT_STATUS,
    key: SENSOR_PROPERTIES.STATUS,
  },
  {
    label: TEXT_MESSAGE,
    key: SENSOR_PROPERTIES.MESSAGE
  }
];
const FLOOD_GATE_SENSOR_INFO = [
  {
    label: TEXT_MANAGEMENT_ID,
    key: SENSOR_PROPERTIES.MANAGE_ID
  },
  {
    label: TEXT_NAME,
    key: SENSOR_PROPERTIES.NAME,
  },
  {
    label: TEXT_DATA_RECEIVED_DATETIME,
    key: SENSOR_PROPERTIES.TX,
  },
  {
    label: TEXT_STATUS,
    key: SENSOR_PROPERTIES.STATUS,
  },
  {
    label: TEXT_FLOOD_GATE_OPENING_LEVEL,
    key: SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL
  }, {
    label: TEXT_OUTER_WATER_LEVEL,
    key: SENSOR_PROPERTIES.OUTER_WATER_LEVEL
  }, {
    label: TEXT_INNER_WATER_LEVEL,
    key: SENSOR_PROPERTIES.INNER_WATER_LEVEL
  }, {
    label: TEXT_POWER_VOLTAGE,
    key: SENSOR_PROPERTIES.POWER_VOLTAGE
  },
  {
    label: TEXT_MESSAGE,
    key: SENSOR_PROPERTIES.MESSAGE
  }
];
const CAMERA_SENSOR_INFO = [
  {
    label: TEXT_NAME,
    key: SENSOR_PROPERTIES.NAME,
  },
  {
    label: TEXT_DATA_RECEIVED_DATETIME,
    key: SENSOR_PROPERTIES.TX,
  },
];
const GENERAL_SENSOR_INFO = [
  {
    label: TEXT_MANAGEMENT_ID,
    key: SENSOR_PROPERTIES.MANAGE_ID
  },
  {
    label: TEXT_NAME,
    key: SENSOR_PROPERTIES.NAME,
  },
  {
    label: TEXT_LATITUDE,
    key: SENSOR_PROPERTIES.LAT
  },
  {
    label: TEXT_LONGITUDE,
    key: SENSOR_PROPERTIES.LONG,
  },
  {
    label: TEXT_DATA_RECEIVED_DATETIME,
    key: SENSOR_PROPERTIES.TX,
  },
  {
    label: TEXT_STATUS,
    key: SENSOR_PROPERTIES.STATUS,
  }
];

const SENSOR_INFO = {
  [SensorType.FLOOD]: FLOOD_SENSOR_INFO,
  [SensorType.FLOOD_GATE]: FLOOD_GATE_SENSOR_INFO,
  [SensorType.CAMERA]: [],
  [SensorType.GENERAL]: GENERAL_SENSOR_INFO,
}

const CameraSensorInfo = ({ targetSensor, targetGroup, isSearchBar, onViewSensorDetail, generalSetting }) => {
  const navigate = useNavigate();
  const [listImageKey6hAgoCamera1, setListImageKey6hAgoCamera1] = useState([])
  const [listImageKey6hAgoCamera2, setListImageKey6hAgoCamera2] = useState([])
  const [listPastFloodImageKeyCamera1, setListPastFloodImageKeyCamera1] = useState([])
  const [listPastFloodImageKeyCamera2, setListPastFloodImageKeyCamera2] = useState([])
  const [image1Src, setImage1Src] = useState('')
  const [image2Src, setImage2Src] = useState('')
  const [typeDisplayCamera, setTypeDisplayCamera] = useState(targetSensor.data.typeDisplayCamera || 'IMAGE')
  const intervalRef1 = useRef(null);
  const intervalRef2 = useRef(null);
  const { currentUser } = useAuth();

  const {
    keyNewestImage,
    swapImageCamera,
    keyNewestImage2,
    cameraFeature,
    typeCamera,
    zoomImageFeature,
    zoomCenterCoordinateY,
    zoomCenterCoordinateX,
    zoomImageRate,
    username,
    password,
    ipAddress,
    sdCardRecording,
    trafficVolumeFeature,
    lastTrafficVolume,
    imageAnalysisFeature,
    imageAnalysisLastFloodDetectedStatus_1,
    imageAnalysisLastFloodDetectedStatus_2,
    imageAnalysisResponse_1,
    imageAnalysisResponse_2,
  } = targetSensor.data

  const isMenuTypeDrawer = generalSetting?.menuType === 'drawer';

  useEffect(() => {
    fetchImageData();

    const interval1 = intervalRef1.current;
    const interval2 = intervalRef2.current;

    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
    };
  }, [targetSensor.id])

  /**
   * HANDLE IMAGE SLIDE
   */
  const fetchImageData = async () => {
    try {
      // Fetch data for camera 1 in parallel
      const [dataCamera1, listPastFloodImageKeyCamera1] = await Promise.all([
        apiListCameraSensorHistories6hAgo(targetSensor.id),
        apiListCameraImagePastFlood(targetSensor.id)
      ]);

      // Process camera 1 data
      const listKeyCamera1 = dataCamera1.data.map(item => item.keyImage);
      const images6hAgoCamera1 = removeRandomElements(listKeyCamera1);
      setListImageKey6hAgoCamera1(images6hAgoCamera1);

      const lastImageCamera1 = listKeyCamera1[listKeyCamera1.length - 1];
      const listPastFloodKeyCamera1 = removeRandomElements(listPastFloodImageKeyCamera1.data.map(item => item.key));
      setListPastFloodImageKeyCamera1([...listPastFloodKeyCamera1, lastImageCamera1]);

      // If DOUBLE camera type, fetch and process data for camera 2 in parallel
      if (typeCamera === 'DOUBLE') {
        const [dataCamera2, listPastFloodImageKeyCamera2] = await Promise.all([
          apiListCameraSensorHistories6hAgo(targetSensor.id, 2),
          apiListCameraImagePastFlood(targetSensor.id, 2)
        ]);

        // Process camera 2 data
        const listKeyCamera2 = dataCamera2.data.map(item => item.keyImage);
        const images6hAgoCamera2 = removeRandomElements(listKeyCamera2);
        setListImageKey6hAgoCamera2(images6hAgoCamera2);

        const lastImageCamera2 = listKeyCamera2[listKeyCamera2.length - 1];
        const listPastFloodKeyCamera1 = removeRandomElements(listPastFloodImageKeyCamera2.data.map(item => item.key));
        setListPastFloodImageKeyCamera2([...listPastFloodKeyCamera1, lastImageCamera2]);
      }
    } catch (error) {
      console.error('Error fetching image data:', error);
    }
  };

  const getUrls = async (listKey = []) => {
    return await Promise.all(listKey.map(async (key) => {
      try {
        const res = await getUrl({ key });
        return res.url.toString()
      } catch (error) {
        console.log("🚀 ~ returnawaitPromise.all ~ error:", error)
        return []
      }
    }));
  }

  function removeRandomElements(array = []) {
    if (array.length > 80) {
      let numberOfElementsToRemove = array.length - 80;
      let itemsToRemove = [];
      while (itemsToRemove.length < numberOfElementsToRemove) {
        const randomIndex = Math.floor(Math.random() * (array.length - 2)) + 1;
        const randomItem = array[randomIndex]
        if (!itemsToRemove.includes(randomItem)) {
          itemsToRemove.push(randomItem);
        }
      }
      return array.filter((item) => !itemsToRemove.includes(item))
    }
    return array
  }

  const getIntervalTime = (list) => list.length <= 40 ? 500 : 20 * 1000 / list.length

  const startSlide = async (list, setImageSrc, intervalRef, endSlide) => {
    if (list.length <= 1) return;
    const urlList = await getUrls(list);
    setTypeDisplayCamera('IMAGE')
    let index = 0;
    const intervalTime = getIntervalTime(urlList);
    intervalRef.current = setInterval(() => {
      setImageSrc(urlList[index]);
      index = (index + 1) % urlList.length;
      if (index === 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        endSlide();
      }
    }, intervalTime);
  };

  const handleRunSlide = (list1, list2) => {
    let slide1Completed = false;
    let slide2Completed = false;

    const endSlide = () => {
      if (slide1Completed && (slide2Completed || typeCamera !== 'DOUBLE')) {
        if (targetSensor.data.typeDisplayCamera === 'VIDEO') {
          setTypeDisplayCamera('VIDEO')
        }
      }
    };

    startSlide(list1, setImage1Src, intervalRef1, () => {
      slide1Completed = true;
      endSlide();
    });
    if (typeCamera === 'DOUBLE') {
      startSlide(list2, setImage2Src, intervalRef2, () => {
        slide2Completed = true;
        endSlide();
      });
    }
  };

  /** Sub components */
  const buttonComponent = ({ condition, label, icon, toolTipContent, toolTipStyle, wrapperStyle, ...props }) => {
    const defaultCondition = generalSetting?.cameraWindowButtonOn
    if (!condition || !defaultCondition) return null;
    return <div className='card_info_btn_camera_wrapper' style={wrapperStyle}>
      <button className='map-page_flex-row card_info_btn_camera' {...props}>
        <span>{label}</span>
        {icon && <Icon icon={icon} />}
      </button>
      {toolTipContent && <div className='card_info_btn_camera_wrapper_pop_up' style={toolTipStyle}>{toolTipContent}</div>}
    </div>
  }

  const subComponent = ({ src, size, cameraNumber }) => {
    return <>
      {typeCamera !== 'DOUBLE' && zoomImageFeature && isMenuTypeDrawer && <div style={{ width: '100%', height: size.height, maxWidth: size.width, overflow: 'hidden', position: 'relative', backgroundColor: '#555', marginTop: 16 }}>
        <img
          src={src}
          style={{
            position: 'absolute',
            width: size.width * zoomImageRate / 100,
            height: size.height * zoomImageRate / 100,
            top: size.height / 2 - size.height * zoomImageRate / 100 * (100 - zoomCenterCoordinateY) / 100,
            left: size.width / 2 - size.width * zoomImageRate / 100 * zoomCenterCoordinateX / 100,
          }}
          alt=''
        />
      </div>}
      {generalSetting?.menuType === 'drawer' && (
        <div className="map_page_card_camera_info_btn_group" style={{ marginTop: 16 }}>
          {buttonComponent({
            condition: currentUser?.accountType !== AccountType.USER,
            label: '別窓動画',
            toolTipContent:
              typeCamera !== 'DOUBLE' ? '長時間の動画閲覧は月額通信量を超過し通信速度が低下します' : '',
            onClick: () => {
              const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(
                password
              )}@${ipAddress}/axis-cgi/mjpg/video.cgi?camera=${cameraNumber}`;
              window.open(location, '_blank');
            },
          })}
          {buttonComponent({
            condition:
              currentUser?.accountType !== AccountType.USER && sdCardRecording && typeCamera !== 'DOUBLE',
            label: '録画動画',
            onClick: () => {
              const location = `http://${ipAddress}/camera/index.html#/recordings`;
              window.open(location, '_blank');
            },
          })}
          {buttonComponent({
            condition: typeCamera === 'DOUBLE',
            label: '詳細',
            icon: IconList.iconAllow,
            onClick: () => {
              onViewSensorDetail(targetSensor, { cameraNumber });
            },
          })}
        </div>
      )}
    </>
  }

  return <div className='map_page_card_camera'>
    <div className={!isSearchBar ? 'map_page_card_camera_info' : 'map-page_flex-column gap-16'} >
      <div className={!isSearchBar ? 'map_page_card_camera_info_text_group' : 'map-page_flex-column gap-16'} >
        {CAMERA_SENSOR_INFO.map(item => {
          if (item.key === SENSOR_PROPERTIES.TX && targetSensor.data.typeDisplayCamera === "VIDEO") return null;
          return <div className='map-page_flex-row map_page_card-info' key={item.key}>
            <p className='normal_text card-info_label'>{item.label}</p>
            <p className='normal_text card-info_value'>{targetSensor[item.key]}</p>
          </div>
        })}
      </div>
      {cameraFeature && generalSetting?.menuType === 'drawer' && (
        <div className='map_page_card_camera_info_btn_group' style={{ flexShrink: 0, minWidth: trafficVolumeFeature ? 300 : 'unset' }}>
          {buttonComponent({
            condition: trafficVolumeFeature,
            label: '交通量',
            toolTipContent: trafficVolumeFeature && lastTrafficVolume && <div>
              <p>{convertDateFormat(lastTrafficVolume.timestamp)} 累積交通量(日)</p>
              {[1, 2, 3, 4, 5, 6].map((i) => {
                if (targetSensor.data[`trafficVolumeScenario${i}`]) {
                  return <div key={i}>{`[${targetSensor.data[`trafficVolumeType${i}`] === "VEHICLE" ? "自動車" : "歩行者"}]${targetSensor.data[`trafficVolumeName${i}`].trim()}: ${addCommasToNumber(lastTrafficVolume[`accumulatedCount_${i}`])}`}</div>
                }
                return null
              })}
            </div>,
            wrapperStyle: { marginRight: 'auto' },
            toolTipStyle: { top: 'calc(100% + 3px)', bottom: 'unset', paddingTop: 0 },
            onClick: () => { onViewSensorDetail(targetSensor, { displayType: 'chart' }) }
          })}
          {buttonComponent({
            condition: typeCamera === "DOUBLE" && currentUser?.accountType !== AccountType.USER && sdCardRecording,
            label: '録画動画',
            onClick: () => {
              const location = `http://${ipAddress}/camera/index.html#/recordings`
              window.open(location, '_blank')
            }
          })}
          {buttonComponent({
            condition: true,
            label: '直近6時間',
            onClick: () => handleRunSlide(listImageKey6hAgoCamera1, listImageKey6hAgoCamera2),
            disabled: intervalRef1.current || intervalRef2.current
          })}
          {buttonComponent({
            condition: true,
            label: '過去登録時',
            onClick: () => handleRunSlide(listPastFloodImageKeyCamera1, listPastFloodImageKeyCamera2),
            disabled: intervalRef1.current || intervalRef2.current
          })}
        </div>
      )}
    </div>
    {cameraFeature && (
      <div className='map_page_card_camera_displayer' style={{ flexDirection: isSearchBar && 'column' }}>
        {/* Camera 1 */}
        <CameraDisplayer
          targetSensor={targetSensor}
          cameraNumber={swapImageCamera ? 2 : 1}
          isDisplayVideo={typeDisplayCamera === "VIDEO"}
          isImageAnalysis={imageAnalysisFeature}
          isInList={false}
          popupText='クリックすると別ウインドウで静止画が大きく表示されます'
          style={typeCamera === "DOUBLE" ? { width: '372px', marginRight: '8px' } : {}}
          imageProps={{
            key: swapImageCamera ? keyNewestImage2 : keyNewestImage,
            src: swapImageCamera ? image2Src : image1Src,
          }}
          buttonStatusProps={{
            status: {
              color: targetGroup.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_2 : imageAnalysisLastFloodDetectedStatus_1]?.color,
              value: targetGroup.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_2 : imageAnalysisLastFloodDetectedStatus_1]?.value
            },
            toolTipContent: swapImageCamera ? imageAnalysisResponse_2 : imageAnalysisResponse_1
          }}
          onClick={() => {
            navigate(`/base/${targetSensor.id}`)
          }}
          subComponent={subComponent}
          videoProps={{
            useFor: 'cameraWindow',
          }}
        />
        {/* Camera 2 - Only show if DOUBLE camera type */}
        {typeCamera === "DOUBLE" && (
          <CameraDisplayer
            targetSensor={targetSensor}
            cameraNumber={swapImageCamera ? 1 : 2}
            isDisplayVideo={typeDisplayCamera === "VIDEO"}
            isImageAnalysis={imageAnalysisFeature}
            isInList={false}
            popupText='クリックすると別ウインドウで静止画が大きく表示されます'
            style={{ width: '372px' }}
            imageProps={{
              key: swapImageCamera ? keyNewestImage : keyNewestImage2,
              src: swapImageCamera ? image1Src : image2Src,
            }}
            buttonStatusProps={{
              status: {
                color: targetGroup.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_1 : imageAnalysisLastFloodDetectedStatus_2]?.color,
                value: targetGroup.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_1 : imageAnalysisLastFloodDetectedStatus_2]?.value
              },
              toolTipContent: swapImageCamera ? imageAnalysisResponse_1 : imageAnalysisResponse_2
            }}
            onClick={() => {
              navigate(`/base/${targetSensor.id}`)
            }}
            subComponent={subComponent}
            videoProps={{
              useFor: 'cameraWindow',
            }}
          />
        )}
      </div>
    )}
  </div >
}

const GeneralSensorInfo = ({ targetSensor, targetGroup, sensorColor }) => {
  const status = targetSensor.status;
  const alarmNames = targetSensor.data.alarmNames?.join(', ') || UNDEFINED_TEXT
  const listItemAlarm = targetSensor.data.listItemAlarm

  const listSignalAbnormal = targetSensor.data.listSignalAbnormal
  const listSignalAbnormalNameStr = listSignalAbnormal?.map(item => targetSensor.data[`nameSignal${item[1]}`])?.join(', ') || UNDEFINED_TEXT
  const listContactAbnormal = targetSensor.data.listContactAbnormal
  const listContactAbnormalNameStr = listContactAbnormal?.map(item => targetSensor.data[`nameContact${item[1]}`])?.join(', ') || UNDEFINED_TEXT

  const getColor = (item) => {
    if (status === -1 || status === 22) return '#000'
    if (status === 23 && listItemAlarm?.includes(item)) return sensorColor
    if (status === 24 && (listSignalAbnormal?.includes(item) || listContactAbnormal?.includes(item))) return sensorColor
    return '#000'
  }
  const customMessage = (message) => {
    if (!message) return ''
    const sensorName = targetSensor.name
    const sensorLocation = targetSensor.location
    return message.replace(/%sensor/g, sensorName).replace(/%place/g, sensorLocation)
  }

  return <>
    <div style={{ margin: '8px 0' }} />
    {Array.from({ length: 5 }).map((_, index) => {
      if (!targetSensor.data[`nameSignal${4 - index}`]) return null;
      return <div key={`A${index}`} className='map-page_flex-row map_page_card-info'>
        <p className='normal_text card-info_label'>{targetSensor.data[`nameSignal${4 - index}`]}</p>
        <div className='card-info_value map-page_flex-row'>
          <p className='normal_text' style={{ color: getColor(`a${4 - index}`), width: '35%' }}>
            {(targetSensor.data[`conversionFactorSignal${4 - index}`] * targetSensor.data[`a${4 - index}`] + targetSensor.data[`correctionCoefficientSignal${4 - index}`])?.toFixed(targetSensor.data?.[`decimalPartLength${4 - index}`] || 0)}
          </p>
          <p className='normal_text' style={{ color: getColor(`a${4 - index}`) }}>{targetSensor.data[`unitSignal${4 - index}`]}</p>
        </div>
      </div>
    })}
    <div style={{ margin: '8px 0' }} />
    {Array.from({ length: 10 }).map((_, index) => {
      if (!targetSensor.data[`nameContact${9 - index}`]) return null;
      return <div key={`S${index}`} className='map-page_flex-row map_page_card-info'>
        <div className='normal_text card-info_label'>{targetSensor.data[`nameContact${9 - index}`]}</div>
        <div className='card-info_value map-page_flex-row'>
          <p className='normal_text' style={{ color: getColor(`s${9 - index}`), width: '35%' }}>{targetSensor.data[`valueContact${9 - index}`] === '1' ? "通知" : "異常検知"}</p>
          <p className='normal_text' style={{ color: getColor(`s${9 - index}`) }}>{targetSensor.data[`s${9 - index}`] ? 'ON' : 'OFF'}</p>
        </div>
      </div>
    })}
    <div style={{ margin: '8px 0' }} />
    {targetSensor.data.connectMethod !== "SOCKET" && <div className='map-page_flex-row map_page_card-info'>
      <p className='normal_text card-info_label'>電源電圧</p>
      <p className='normal_text card-info_value'>{targetSensor.data.powerVoltage}V</p>
    </div>}
    <div className='map-page_flex-row map_page_card-info'>
      <p className='normal_text card-info_label'>メッセージ</p>
      <p className='normal_text card-info_value'>{customMessage(targetGroup?.messages[targetSensor.status]?.message)}</p>
    </div>
    <div className='map-page_flex-row map_page_card-info'>
      <p className='normal_text card-info_label'></p>
      <p className='normal_text card-info_value'>警報: {alarmNames}</p>
    </div>
    <div className='map-page_flex-row map_page_card-info'>
      <p className='normal_text card-info_label'></p>
      <p className='normal_text card-info_value'>計測器異常: {listSignalAbnormalNameStr}</p>
    </div>
    <div className='map-page_flex-row map_page_card-info'>
      <p className='normal_text card-info_label'></p>
      <p className='normal_text card-info_value'>異常通知: {listContactAbnormalNameStr}</p>
    </div>
  </>
}

const SensorInfoCard = ({ markerId, width, isDrag, isSearchBar, onViewSensorDetail }) => {
  const { sensors } = useSensors();
  const { sensorGroups } = useSensorGroups();
  const { generalSetting } = useGeneralSetting();

  /***** Main Render ****/
  const targetSensor = sensors.find(s => s.id === markerId);
  const targetGroup = sensorGroups.find(g => g.id === targetSensor.groupId);
  const sensorColor = targetGroup.messages[targetSensor.status]?.color;
  const sensorStatus = targetGroup.messages[targetSensor.status]?.value;

  const customMessage = (message) => {
    if (!message) return ''
    const sensorName = targetSensor.name
    const sensorLocation = targetSensor.location
    return message.replace(/%sensor/g, sensorName).replace(/%place/g, sensorLocation)
  }

  return (
    <div className={`map-page_flex-row map_page_card-content ${isDrag ? 'dragble' : ''}`} >
      <div className='map-page_flex-row map_page_card-content-container'>
        {
          (SENSOR_INFO[targetGroup.type]).map((item, index) => {
            if (item.key === SENSOR_PROPERTIES.STATUS) {
              return (
                <div key={index} className='map-page_flex-row map_page_card-info'>
                  <p className='normal_text card-info_label' style={{ '--width': width }}>{item.label}</p>
                  <p className='map-page_flex-row normal_text card-info_value'>
                    {
                      sensorStatus &&
                      <span
                        className={'card-info_value-text'}
                        style={{
                          background: sensorColor,
                          color: hexToRGB(sensorColor) >= 400 ? 'black' : 'white'
                        }}
                      >
                        {sensorStatus}
                      </span>
                    }
                    {
                      targetSensor.isLocked === LockState.LOCKED &&
                      generalSetting?.alertOn &&
                      <span className='card-info_value-text' style={{ background: '#ff0000' }}>警報ラッチ</span>
                    }
                  </p>
                </div>
              )
            }
            else if (item.key === SENSOR_PROPERTIES.FLOOD_GATE_OPENING_LEVEL) {
              return <div key={index} className='map-page_flex-row map_page_card-info'>
                <p className='normal_text card-info_label' style={{ '--width': width }}>{item.label}</p>
                <p className='normal_text card-info_value'>{(targetSensor.data && targetSensor.data.gateOpeningLevel?.toFixed(targetSensor.data.openingLevelDisplay || 0) || '') + targetSensor.data.gateOpeningUnit}</p>
              </div>
            }
            else if (item.key === SENSOR_PROPERTIES.OUTER_WATER_LEVEL || item.key === SENSOR_PROPERTIES.INNER_WATER_LEVEL) {
              return <div key={index} className='map-page_flex-row map_page_card-info'>
                <p className='normal_text card-info_label' style={{ '--width': width }}>{item.label}</p>
                <p className='normal_text card-info_value'>{(targetSensor.data && targetSensor.data[item.key.replace('data.', '')]?.toFixed(2) || '') + 'm'}</p>
              </div>
            }
            else if (item.key === SENSOR_PROPERTIES.POWER_VOLTAGE) {
              return <div key={index} className='map-page_flex-row map_page_card-info'>
                <p className='normal_text card-info_label' style={{ '--width': width }}>{item.label}</p>
                <p className='normal_text card-info_value'>{(targetSensor.data && targetSensor.data[item.key.replace('data.', '')]?.toFixed(1) || '') + 'V'}</p>
              </div>
            }
            else if (item.key === 'message') {
              return <div key={index} className='map-page_flex-row map_page_card-info'>
                <p className='normal_text card-info_label' style={{ '--width': width }}>{item.label}</p>
                <p className='normal_text card-info_value'>{customMessage(targetGroup?.messages[targetSensor.status]?.message)}</p>
              </div>
            }
            return (
              <div key={index} className='map-page_flex-row map_page_card-info'>
                <p className='normal_text card-info_label' style={{ '--width': width }}>{item.label}</p>
                <p className='normal_text card-info_value'>{targetSensor && targetSensor[item.key]}</p>
              </div>
            )
          })
        }
        {targetGroup.type === SensorType.CAMERA && (
          <CameraSensorInfo targetSensor={targetSensor} targetGroup={targetGroup} isSearchBar={isSearchBar} onViewSensorDetail={onViewSensorDetail} generalSetting={generalSetting} />
        )}
        {targetGroup.type === SensorType.GENERAL && (
          <GeneralSensorInfo targetSensor={targetSensor} targetGroup={targetGroup} sensorColor={sensorColor} />
        )}
      </div>
    </div>
  )
}

SensorInfoCard.propTypes = {
  sensor: PropTypes.object.isRequired,
  width: PropTypes.string,
  isDrag: PropTypes.bool,
}
SensorInfoCard.defaultProps = {
  sensor: {},
  width: '',
  isDrag: false,
}

const PopupContent = ({ sensors, onCLose, onPopupMouseLeave, onUnlockSensor, onViewSensorDetail, onSendMail }) => {
  const isCamera = sensors && sensors.length > 0 && sensors[0].id.includes("camera");
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1367);
  
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1367);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className='map_page_sensor_card' onMouseLeave={onPopupMouseLeave}>
      {(!isCamera || !isDesktop) && (
        <div className='map_page_close_btn_container'>
          <div className='map-page_flex-row map_page_close_btn' onClick={onCLose} onTouchStart={onCLose}>
            <Icon icon={IconList.iconClose} containerStyle='icon_container' />
            <p className='close_btn-text'>閉じる</p>
          </div>
        </div>
      )}
      <div className='map_page_sensor_container'>
        {
          sensors?.map((sensor) => (
            <div key={sensor.id}>
              <SensorInfoCard markerId={sensor.id} isDrag={true} onViewSensorDetail={onViewSensorDetail} />
              <FunctionCard
                markerId={sensor.id}
                onUnlock={onUnlockSensor}
                onViewSensorDetail={onViewSensorDetail}
                onSendMail={onSendMail}
                isReload={true} />
            </div>
          ))
        }
      </div>
    </div>
  )
}

PopupContent.propTypes = {
  setIsOpen: PropTypes.func.isRequired,
  sensors: PropTypes.array,
  onUnlockSensor: PropTypes.func,
  onViewSensorDetail: PropTypes.func,
  onSendMail: PropTypes.func,
}

PopupContent.defaultProps = {
  setIsOpen: () => { },
  sensors: [],
  onUnlockSensor: () => { },
  onViewSensorDetail: (sensor) => { },
  onSendMail: (sensor) => { },
}

const FunctionCard = ({ isReload, markerId, onUnlock, onViewSensorDetail, onSendMail }) => {
  const { generalSetting } = useGeneralSetting();
  const { sensorGroups } = useSensorGroups();
  const { sensors, reload } = useSensors();
  const sensor = sensors.find(s => s.id === markerId);
  const targetGroup = sensorGroups.find(g => g.id === sensor.groupId);

  const showCameraButton =
    targetGroup?.type === SensorType.CAMERA
      ? sensor.data?.typeCamera !== "DOUBLE" &&
      generalSetting?.menuType === "drawer" &&
      !!generalSetting?.cameraWindowButtonOn
      : true;

  /***** Main Render ****/
  const handleClick = async (e) => {
    e.stopPropagation();
    onSendMail(sensor);
  }
  const isLocked = () => {
    if (sensor?.isLocked === LockState.LOCKED && generalSetting?.alertOn) {
      const status = sensor.status;
      if (status === -1) {
        return true;
      } else {
        const messageInfo = targetGroup?.messages && targetGroup.messages[status];
        return messageInfo.value !== SENSOR_STATUS_ALERT;
      }
    }
    return false;
  }
  /**** Event Handlers ****/
  /**** Main Render ****/
  return (
    <div className='map-page_flex-row map_page_card-function'>
      {
        isLocked() &&
        <button className='map-page_flex-row function-unclock'
          onClick={() => onUnlock(sensor)}
          onTouchStart={() => onUnlock(sensor)}>
          <span>警報復旧</span>
        </button>
      }
      {showCameraButton &&
        <button className='map-page_flex-row function-detail' onClick={() => { onViewSensorDetail(sensor) }} onTouchStart={() => { onViewSensorDetail(sensor) }}>
          <span>詳細</span>
          <Icon icon={IconList.iconAllow} />
        </button>}
      {targetGroup.type !== SensorType.CAMERA &&
        <button className='function-email' onClick={handleClick} onTouchStart={handleClick}>
          <Icon icon={IconList.iconMail} containerStyle='icon_container' />
        </button>
      }
      {isReload && showCameraButton &&
        <Icon
          icon={IconList.iconReload}
          containerStyle='icon_container'
          onClick={reload} />}
    </div>
  )
}

FunctionCard.propTypes = {
  isReload: PropTypes.bool,
  markerId: PropTypes.string.isRequired,
  onUnlock: PropTypes.func.isRequired,
  onViewSensorDetail: PropTypes.func,
  onSendMail: PropTypes.func,
}

FunctionCard.defaultProps = {
  isReload: false,
  markerId: '',
  onUnlock: (sensor) => { },
  onViewSensorDetail: (sensor) => { },
  onSendMail: () => { },
}

export {
  FunctionCard, PopupContent, SensorInfoCard
};
